module.exports = {
  skipWords: [
    'the',
    'of',
    'and',
    'in',
    'a',
    'an',
    'not',
    'as',
    'at',
    'but',
    'to',
    'be',
    'it',
    'for',
    'by',
    'from',
    'on',
    'with',
    'that',
    'this',
    'or',
    'is',
    'no',
  ],
}
